import { c as _c } from "react/compiler-runtime";
import { HelpCircleIcon } from '@systemeio/icons';
import { centsToUnits } from '@systemeio/util';
import { AffiliateDashboardVendorAvatarButton } from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-avatar-button';
import { useAffiliateDashboardEmptyState } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-empty-state';
import { useAffiliateDashboardInvoices } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-invoices';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardInvoicesInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-invoices-interface';
import { AffiliateInvoiceState } from 'modules/affiliate/components/affiliate-invoice-state';
import { AffiliateMobileCard } from 'modules/affiliate/components/affiliate-mobile-card';
import { InvoiceDetailsModal } from 'modules/payment/invoices/components/invoice-details-modal';
import { InvoiceStateEnum } from 'modules/payment/invoices/enums/invoice-state-enum';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Button } from 'shared/components';
import ListingLayout from 'shared/components/listing-layout';
import { RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useDownloadInvoiceLink } from 'shared/hooks/use-download-invoice-link';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { currencyFormat } from 'shared/utils/currency-format';
interface AffiliateDashboardInvoicesProps {
  mainFilter: AffiliateDashboardFilterInterface;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardInvoices = t0 => {
  const $ = _c(89);
  const {
    mainFilter,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const router = useRouter();
  const purchaseInvoiceId = router.query.purchaseInvoiceId as string;
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    setFirstPage
  } = usePagination(true);
  const [invoiceId, setInvoiceId] = useState(null);
  let t1;
  let t2;
  if ($[0] !== purchaseInvoiceId) {
    t1 = () => {
      if (!isNaN(Number(purchaseInvoiceId))) {
        setInvoiceId(Number(purchaseInvoiceId));
      }
    };
    t2 = [purchaseInvoiceId];
    $[0] = purchaseInvoiceId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const getDownloadInvoiceLink = useDownloadInvoiceLink();
  let t3;
  if ($[3] !== limit || $[4] !== mainFilter || $[5] !== pagination) {
    t3 = {
      filter: mainFilter,
      pagination,
      limit
    };
    $[3] = limit;
    $[4] = mainFilter;
    $[5] = pagination;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    affiliateInvoices,
    counter
  } = useAffiliateDashboardInvoices(t3);
  const t4 = !!mainFilter.vendorId;
  let t5;
  if ($[7] !== affiliateInvoices || $[8] !== t4) {
    t5 = {
      data: affiliateInvoices,
      isFiltered: t4
    };
    $[7] = affiliateInvoices;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    tableData,
    emptyStateProps
  } = useAffiliateDashboardEmptyState("invoices", t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setInvoiceId(null);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const closeModal = t6;
  let t7;
  if ($[11] !== setFirstPage) {
    t7 = () => {
      setFirstPage();
    };
    $[11] = setFirstPage;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== mainFilter || $[14] !== setFirstPage) {
    t8 = [setFirstPage, mainFilter];
    $[13] = mainFilter;
    $[14] = setFirstPage;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  useDidUpdateEffect(t7, t8);
  let t9;
  if ($[16] !== setMainFilter) {
    t9 = invoice => <AffiliateDashboardVendorAvatarButton vendor={invoice.user} onClick={() => setMainFilter(prev => ({
      ...prev,
      vendorId: invoice.user.id
    }))} />;
    $[16] = setMainFilter;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const renderAvatar = t9;
  const renderVendorDetails = _temp;
  let t10;
  if ($[18] !== renderAvatar) {
    t10 = invoice_1 => <div className="flex min-w-0 items-center gap-3">{renderAvatar(invoice_1)}{renderVendorDetails(invoice_1)}</div>;
    $[18] = renderAvatar;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const renderVendor = t10;
  let t11;
  if ($[20] !== user?.dashboardLocale) {
    t11 = invoice_2 => <span className="text-text-primary">{currencyFormat(centsToUnits(invoice_2.invoice.amount), invoice_2.invoice.currency, user?.dashboardLocale)}</span>;
    $[20] = user?.dashboardLocale;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const renderAmount = t11;
  let t12;
  if ($[22] !== t) {
    t12 = invoice_3 => <div className="flex items-center gap-1"><AffiliateInvoiceState state={invoice_3.invoice.state} />{invoice_3.invoice.state === InvoiceStateEnum.unpaid && <Button aria-label={t("global.help")} onClick={() => {
        setInvoiceId(invoice_3.id);
      }} size="icon-xs" variant="ghost-color"><HelpCircleIcon /></Button>}</div>;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const renderState = t12;
  let t13;
  if ($[24] !== t) {
    t13 = t("dashboard.affiliate_dashboard.vendor");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== renderVendor || $[27] !== t13) {
    t14 = {
      key: "details",
      header: t13,
      widthPercent: 37,
      onRender: renderVendor
    };
    $[26] = renderVendor;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.affiliate.amount");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== renderAmount || $[32] !== t15) {
    t16 = {
      key: "amount",
      header: t15,
      widthPercent: 18,
      onRender: renderAmount
    };
    $[31] = renderAmount;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("dashboard.affiliate.state.label");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== renderState || $[37] !== t17) {
    t18 = {
      key: "state",
      header: t17,
      widthPercent: 18,
      onRender: renderState
    };
    $[36] = renderState;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t) {
    t19 = t("global.date");
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t19) {
    t20 = {
      key: "date",
      header: t19,
      widthPercent: 19,
      onRender: _temp2
    };
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t14 || $[44] !== t16 || $[45] !== t18 || $[46] !== t20) {
    t21 = [t14, t16, t18, t20];
    $[43] = t14;
    $[44] = t16;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  const columns = t21;
  let t22;
  if ($[48] !== t) {
    t22 = t("dashboard.affiliate.invoices");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("dashboard.affiliate.download_invoice");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== getDownloadInvoiceLink) {
    t24 = invoice_5 => getDownloadInvoiceLink(invoice_5.id);
    $[52] = getDownloadInvoiceLink;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = {
      openLink: [{
        caption: t23,
        name: "download-invoice",
        openInNew: true,
        setHref: t24
      }]
    };
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== renderAmount || $[58] !== renderState || $[59] !== renderVendor) {
    t26 = (invoice_6, actions) => <div className="flex items-center gap-5"><div className="min-w-0 flex-5">{renderVendor(invoice_6)}</div><div className="min-w-0 flex-2">{renderAmount(invoice_6)}</div><div className="min-w-0 flex-3">{renderState(invoice_6)}</div><div className="min-w-0 flex-3"><RelativeTime time={invoice_6.invoice.date} /></div>{actions}</div>;
    $[57] = renderAmount;
    $[58] = renderState;
    $[59] = renderVendor;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== renderAmount || $[62] !== renderAvatar || $[63] !== renderState) {
    t27 = (invoice_7, actions_0) => <AffiliateMobileCard avatar={renderAvatar(invoice_7)} aside={renderAmount(invoice_7)} footer={<div className="flex items-center justify-between gap-3">{renderState(invoice_7)}{actions_0}</div>}>{renderVendorDetails(invoice_7)}<div className="mt-1"><RelativeTime time={invoice_7.invoice.date} /></div></AffiliateMobileCard>;
    $[61] = renderAmount;
    $[62] = renderAvatar;
    $[63] = renderState;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== limit || $[66] !== setLimit) {
    t28 = {
      limit,
      setLimit
    };
    $[65] = limit;
    $[66] = setLimit;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== pagination || $[69] !== setPagination) {
    t29 = {
      pagination,
      setPagination
    };
    $[68] = pagination;
    $[69] = setPagination;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== columns || $[72] !== emptyStateProps || $[73] !== t25 || $[74] !== t26 || $[75] !== t27 || $[76] !== t28 || $[77] !== t29 || $[78] !== tableData) {
    t30 = <Table actions={t25} data={tableData} renderTabletRow={t26} renderMobileRow={t27} columns={columns} limiter={t28} paginator={t29} emptyStateProps={emptyStateProps} />;
    $[71] = columns;
    $[72] = emptyStateProps;
    $[73] = t25;
    $[74] = t26;
    $[75] = t27;
    $[76] = t28;
    $[77] = t29;
    $[78] = tableData;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== counter || $[81] !== t22 || $[82] !== t30) {
    t31 = <ListingLayout counter={counter} title={t22}>{t30}</ListingLayout>;
    $[80] = counter;
    $[81] = t22;
    $[82] = t30;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== invoiceId) {
    t32 = <InvoiceDetailsModal invoiceId={invoiceId} onCloseModal={closeModal} />;
    $[84] = invoiceId;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== t31 || $[87] !== t32) {
    t33 = <>{t31}{t32}</>;
    $[86] = t31;
    $[87] = t32;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  return t33;
};
export default AffiliateDashboardInvoices;
function _temp(invoice_0) {
  return <div className="flex min-w-0 flex-col">{invoice_0.user.affiliateProgramBrandName && <span className="text-text-primary truncate">{invoice_0.user.affiliateProgramBrandName}</span>}<span className="text-text-tertiary truncate text-sm">{invoice_0.user.email}</span></div>;
}
function _temp2(invoice_4) {
  return <RelativeTime time={invoice_4.invoice.date} />;
}